module.exports = __webpack_public_path__ + "img/1.75ce36d0.png";